import { Logtail } from "@logtail/browser";
import {getClientConfig} from "@root/server/client/esweb/src/lib/config.ts";

const config = getClientConfig();

export const logger = config.BS_SOURCE_TOKEN ? new Logtail(config.BS_SOURCE_TOKEN, {
    endpoint: config.BS_INGEST_HOST!,
}) : console;

